
import { combineReducers } from 'redux';
import { AbandonedCartReducer } from '../checkout/reducers/abandonedCart/abandonedCartReducer';
import { BrandFormPodioReducer } from '../checkout/reducers/umbracobrandandpodio/checkoutBrandPodioReducer';
import { nextstepreducer } from '../checkout/nextstep/nextstep';
import {CustomerReducer} from '../checkout/reducers/checkout2/CustomerReducer'
import { ParticipantsReducer, CapacityReducer } from "../checkout/reducers/checkout2/ParticipantsReducer";
import {VariationDepartureSelectReducer} from '../../redux/checkout/reducers/checkout2/VariationDepartureSelectReducer';
import ProductsByFilterReducer from '../checkout/reducers/products/filter/FilterReducer';
import { AddonReducer } from '../checkout/reducers/checkout3/AddonReducer';
import { OrderReducer } from "../checkout/reducers/checkout4/OrderReducer";

import { DiscountReducer } from '../checkout/reducers/checkout2/DiscountReducer';
import { PickupPointReducer } from '../checkout/checkout2/PickupPointReducer';


/*home */

import {filterReducer} from '../home/filters/filterReducer';
import { searchTripsReducer } from '../home/searchTrips/searchTripsReducer';
import { checkoutReducer } from '../checkout/checkoutReducer';
import { OrderConfirmReducer } from '../checkout/orderConfirmation/orderconfirmReducer';
import { homePageDataReducer } from '../home/page/homePageReducer';
import { productDetailReducer } from '../productDetail/productDetailReducer';
import { customerAuthReducer } from '../loginLogout/reducer';



 const reducers= combineReducers({
  abandonedCart:AbandonedCartReducer,
  BrandFormPodioReducer:BrandFormPodioReducer,
  nextcheckoutstep:nextstepreducer,
  CustomerReducer:CustomerReducer,
  ParticipantsReducer:ParticipantsReducer,
  VariationDepartureSelectReducer:VariationDepartureSelectReducer,
  CapacityReducer:CapacityReducer,
  ProductsByFilterReducer:ProductsByFilterReducer,
  AddonReducer:AddonReducer,
  OrderReducer:OrderReducer,
  filterData:filterReducer,
  trips:searchTripsReducer,
  checkoutdata:checkoutReducer,
  pickupPoint:PickupPointReducer,
  orderConfirm:OrderConfirmReducer,
  discount:DiscountReducer,
  homePageData:homePageDataReducer,
  productDetails:productDetailReducer,
  customerAuth:customerAuthReducer
  });

 export default reducers